<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="クーポンの使用条件"
        ok-title="クーポンの使用方法"
        ok-variant="yokumiru-orange"
        cancel-title="閉じる"
        cancel-variant="yokumiru-gray"
        @ok="handleOk"
        @cancel="close"
        @hidden="close">
        <div class="modal-body">
            <div v-if="doctor !== null">
                <div class="card">
                    <div class="card-header">
                        <div class="font-weight-bold">医師基本情報</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-8 order-2 order-md-1 medical-courses-list">
                                <h4>{{ doctor.full_name }}<span class="small">（{{ doctor.full_name_kana }}）</span></h4>
                                <div class="font-weight-bold">{{ $locale.consultation_host }}科</div>
                                <template v-for="medical_course in doctor.medical_courses">
                                    <b-button
                                        class="m-1 vc-medical-course"
                                        size="sm"
                                        variant="yokumiru-gray">
                                        {{ medical_course.name }}
                                    </b-button>
                                </template>
                                <div class="font-weight-bold mt-2">自己紹介文</div>
                                <div>{{ doctor.introduction }}</div>
                            </div>

                            <div class="col-12 col-md-4 order-1 order-md-2 mb-3">
                                <img
                                    class="u-fit"
                                    :src="doctor.presigned_url"
                                    :alt="doctor.full_name">
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="coupon !== null"
                    class="mt-3">
                    <b-table
                        class="mb-0"
                        :responsive="true"
                        :items="[coupon]"
                        :fields="fields">
                        <template v-slot:cell(name)="data">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <div>{{ data.item.name }}</div>
                                    <div v-if="data.item.campaign" class="small text-muted">{{ data.item.campaign.name }}</div>
                                </div>
                            </div>
                        </template>

                        <template v-slot:cell(discount)="data">
                            <div>{{ discount(data.item).toLocaleString() }}円</div>
                        </template>

                        <template v-slot:cell(amount)="data">
                            <div>{{ data.item.amount }}</div>
                        </template>

                        <template v-slot:cell(expired_at)="data">
                            <div v-if="isExpiredNothing(data.item)">
                                <span>無期限</span>
                            </div>
                            <div v-else-if="data.item.expired_at" class="u-palt">
                                <span>{{ expiredDate(data.item) }}&nbsp;（</span><!--
                         --><span :class="expiredDayCSS(data.item)">{{ expiredDay(data.item) }}</span><!--
                         --><span>）</span>
                                <span>{{ expiredTime(data.item) }}</span>
                            </div>
                            <div v-else class="text-muted">未取得</div>
                            <timezone-box-common
                                v-if="timezone && data.item.expired_at && !isExpiredNothing(data.item)"
                                :format="data.item.expired_at"
                                timezone="Asia/Tokyo"
                                :force-display="timezone !== 'Asia/Tokyo'">
                            </timezone-box-common>
                        </template>
                    </b-table>
                </div>

                <ul class="mt-4">
                    <li>このクーポンは「{{ doctor.full_name }}」医師の相談予約時のみご利用いただけます。</li>
                    <li>そのほかの医師にはご利用いただけませんのでご注意ください。</li>
                    <li>複数クーポンの併用はできません。</li>
                </ul>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'

    export default {
        name: 'CouponUseConditionModal',

        props: {
            plan: {
                type: Object,
                required: true,
            },
            campaigns: {
                type: Array,
                required: true,
            },
            timezone: {
                type: String,
                default: 'Asia/Tokyo',
            },
        },

        data: function () {
            return {
                modalShow: false,
                helper: YokumiruHelper,
                coupon: null,
                doctor: null,
                fields: [
                    {
                        key: 'name',
                        label: 'クーポン名',
                        sortable: false,
                    },
                    {
                        key: 'discount',
                        label: '割引額',
                        sortable: false,
                    },
                    {
                        key: 'expired_at',
                        label: '使用期限',
                        sortable: false,
                    },
                ],
            }
        },

        created: function () {
            bus.$on('open-modal-coupon-use-condition', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-coupon-use-condition')
        },

        methods: {
            /**
             * モーダル表示
             *
             * @param {object} coupon
             */
            open: function (coupon) {
                this.modalShow = true
                this.coupon = coupon
                this.doctor = coupon.doctor
            },

            /**
             * モーダル非表示
             */
            close: function () {
                this.modalShow = false
            },

            /**
             * クーポンの使用方法ボタン押下時
             */
            handleOk: function (e) {
                e.preventDefault()
                bus.$emit('open-modal-how-to-use-coupon')
            },

            /**
             * 割引率・金額計算
             *
             * @param {object} coupon
             * @return {number}
             */
            discount: function (coupon) {
                if (coupon.category === constants.couponCategory.plan) {
                    return this.calcDiscount(this.plan.price_subscription, coupon)
                }
                if (coupon.category === constants.couponCategory.consultation) {
                    return this.calcDiscount(this.plan.price_consultation, coupon)
                }
            },

            /**
             * 計算処理
             *
             * @param {number} price
             * @param {object} coupon
             * @return {number}
             */
            calcDiscount: function (price, coupon) {
                if (coupon.discount_unit === 'percent') {
                    return price * coupon.discount / 100
                }
                else if (coupon.discount_unit === 'static') {
                    return coupon.discount
                }
                else if (coupon.discount_unit === 'daily') {
                    return coupon.discount
                }
                return 0
            },

            /**
             * クーポン使用期限の無期限判定
             *
             * @param {object} coupon
             * @return {boolean}
             */
            isExpiredNothing: function (coupon) {
                if (coupon.expired_at === '2100-01-01 00:00:00') {
                    return true
                }

                const campaign = this.campaigns.find(campaign => campaign.id === coupon.campaign_id)
                if (!campaign) return false

                return campaign.expire_days === null
            },

            /**
             * クーポン使用期限表記（日付）
             *
             * @param {object} coupon
             * @return {string}
             */
            expiredDate: function (coupon) {
                if (coupon.expired_at) {
                    return this.helper.dateForHuman(coupon.expired_at, this.timezone)
                }
                return ''
            },

            /**
             * クーポン使用期限表記（時刻）
             *
             * @param {object} coupon
             * @return {string}
             */
            expiredTime: function (coupon) {
                if (coupon.expired_at) {
                    return this.helper.timeForHuman(coupon.expired_at, this.timezone)
                }
                return ''
            },

            /**
             * クーポン使用期限表記（曜日）
             *
             * @param {object} coupon
             * @return {string}
             */
            expiredDay: function (coupon) {
                if (coupon.expired_at) {
                    return this.helper.dayForHuman(coupon.expired_at, this.timezone)
                }
                return ''
            },

            /**
             * クーポン使用期限表記（曜日）のCSS
             *
             * @param {object} coupon
             * @return {string}
             */
            expiredDayCSS: function (coupon) {
                let userTime, day
                if (coupon.expired_at) {
                    userTime = this.helper.userTime(coupon.expired_at, this.timezone)
                    day = userTime.day()
                    if (day === 0) return 'text-danger small font-weight-bold'
                    if (day === 6) return 'text-yokumiru-blue small font-weight-bold'
                }
                return ''
            },
        },
    }
</script>

<style scoped lang="scss">
.vc-medical-course {
    cursor: default !important;

    &:hover {
        border-color: #98a6ad !important;
        background: #98a6ad !important;
    }

    &:focus {
        box-shadow: none !important;
    }
}
</style>
